import React from 'react';
import styles from '../cubonetattoo/cubonetattoo.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import FacebookIcon from '../../icons/facebookIcon.tsx';

const Cubonetattoo: React.FC = () => {
    return (
        <div className={styles.cubonetattoo}>
            <div className={styles["body-thunder"]}>
                <div className={styles["container-thunder"]}>
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            topLeft={true}
                            linkInterno={true}
                            href="/cubonetattoo/sobremim"
                            title="SOBRE MIM"
                            icon={<CatalogIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            topRight={true}
                            linkInterno={true}
                            href="/cubonetattoo/galeria"
                            title="GALERIA"
                            icon={<TattooIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517997449691?text=Olá, vim pelo link na bio..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/cubonetattoo"
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cubonetattoo;
